import { render, staticRenderFns } from "./ParameterModal.vue?vue&type=template&id=18c2d162&"
import script from "./ParameterModal.vue?vue&type=script&lang=ts&"
export * from "./ParameterModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports